/// <reference path="appbase.ts" />

namespace TerminalApp {
    class OrderData {
        btn: HTMLElement;
        cb: SP.CheckboxDoodle;
        data: SP.PickProfileOrderInfo;
        searchstring: string;
        constructor(btn: HTMLElement, cb: SP.CheckboxDoodle, data: SP.PickProfileOrderInfo) {
            this.btn = btn;
            this.cb = cb;
            this.data = data;
            this.searchstring = [this.data.orderNo, this.data.referenceNo, this.data.recipient.name, this.data.recipient.attention, this.data.recipient.street1, this.data.recipient.street2, this.data.recipient.city, this.data.recipient.country, this.data.recipient.email, this.data.recipient.phone, this.data.recipient.zipcode].join(" ").toLowerCase();

            if (this.data.productionItemInfo) {
                this.searchstring += " " + this.data.productionItemInfo.description.toLowerCase() + " " + this.data.productionItemInfo.sku.toLowerCase();
            }
        }

        isMatch(keyword: string) {
            var words = keyword.toLowerCase().split(' ');
            for (let i = 0; i < words.length; i++) { if (this.searchstring.indexOf(words[i]) == -1) return false; }
            return true;
        }
    }

    class PickAssistant {
        container = document.createElement("div");
        inner = document.createElement("div");
        order_result_container = document.createElement("div");
        select_filtered_cb = document.createElement("input");
        select_filtered_doodle: SP.CheckboxDoodle;
        filter_input = document.createElement("input");
        headline = document.createElement("h1");
        finish_button: HTMLElement;
        clear_button: HTMLElement;
        initialized = false;
        items: OrderData[] = [];
        picks: number[] = [];
        onClose: () => void;

        constructor() {

            this.container.classList.add("assistant");

            //close button
            var close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            close_button.addEventListener("click", () => {
                this.close();
            });

            //setup sender screen
            this.inner.appendChild(this.headline);
            this.filter_input.type = "text";
            this.filter_input.placeholder = SP.Localize("sentance_filter_orders") + " ...";
            this.filter_input.autocomplete = "off";
            this.filter_input.tabIndex = 1;
            this.filter_input.classList.add("search_input", "form-control");
            this.filter_input.addEventListener("keyup", () => {
                this.filter_orders(this.filter_input.value);
            });

            this.inner.append(this.select_filtered_cb);
            this.inner.append(this.filter_input);

            this.select_filtered_doodle = new SP.CheckboxDoodle(this.select_filtered_cb);
            var s = this.select_filtered_doodle.track.style;
            s.position = "absolute";
            s.zIndex = "100";
            s.right = "30px";
            s.bottom = "initial";
            s.top = "110px";

            this.select_filtered_doodle.onChange = () => {
                for (let i = 0; i < this.items.length; i++) {
                    let itm = this.items[i];
                    itm.cb.checked = itm.btn.style.display == "block" && this.select_filtered_doodle.checked;
                }
            }

            this.order_result_container.style.position = "absolute";
            this.order_result_container.style.width = "100%";
            this.order_result_container.style.bottom = "100px";
            this.order_result_container.style.top = "180px";
            this.order_result_container.style.overflowY = "scroll";
            this.order_result_container.classList.add("simple-scroll");

            this.inner.append(this.order_result_container);
            this.container.appendChild(this.inner);

            this.finish_button = this.inner.appendChild(document.createElement("div"))
            this.finish_button.classList.add("btn", "noselect", "grad-green", "fixed-btm");
            this.finish_button.style.left = "145px";
            this.finish_button.style.width = "auto";
            this.finish_button.style.right = "18px";
            var action = this.finish_button.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_finish");

            this.finish_button.addEventListener("click", async () => {
                this.close();
            });


            this.clear_button = this.inner.appendChild(document.createElement("div"))
            this.clear_button.classList.add("btn", "noselect", "grad-red", "fixed-btm");
            this.clear_button.style.width = "120px";
            this.clear_button.style.left = "17px";
            this.clear_button.style.right = "initial";
            var action = this.clear_button.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_reset");

            this.clear_button.addEventListener("click", async () => {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].cb.checked) {
                        this.items[i].cb.checked = false;
                    }
                }
                this.select_filtered_doodle.checked = false;
                this.filter_orders('');
            });
        }


        async filter_orders(keyword: string) {
            var allSelected = true;
            for (let i = 0; i < this.items.length; i++) {
                let itm = this.items[i];
                var show = !keyword || itm.isMatch(keyword);
                itm.btn.style.display = show ? "block" : "none";
                if (show && !itm.cb.checked) allSelected = false;
            }

            //unbinde event while changing, dont want callback now
            var _tmp = this.select_filtered_doodle.onChange;
            this.select_filtered_doodle.onChange = null;
            this.select_filtered_doodle.checked = allSelected;
            this.select_filtered_doodle.onChange = _tmp;

        }

        clear() {
            this.currentList = "";
            this.items = [];
            this.picks = [];
        }

        currentList: string;

        async setList(profileId: string) {
            if (this.currentList != profileId) {
                this.currentList = profileId;
                this.order_result_container.innerHTML = "";
                var data = await SP.Data.PickProfile.getPickProfileInfo(profileId);

                for (let i = 0; i < data.orders.length; i++) {
                    let order = data.orders[i];
                    this.addSenderButton(order);

                }
            }

        }

        async init() {
            if (this.initialized) return;
            this.initialized = true;
        }

        async open(profileId: string, name: string) {
            this.headline.innerHTML = name;
            await this.init();
            await this.setList(profileId);
            this.filter_input.value = "";
            this.container.style.display = "block";
        }



        close() {
            this.picks = [];
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].cb.checked) {
                    this.picks.push(this.items[i].data.id);
                }
            }


            this.container.style.display = "none";
            if (this.onClose) this.onClose();
        }




        addSenderButton(data: SP.PickProfileOrderInfo) {
            var c = this.order_result_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.style.height = "80px";
            c.style.color = "#9f9f9f";
            var action = c.appendChild(document.createElement("span"));
            action.classList.add("orderno");
            action.innerHTML = "<b>" + data.orderNo + "</b><br><span class='small'>" + data.referenceNo + ", " + data.lineCount + " " + SP.Localize("word_lines") + ", " + data.itemCount + " " + SP.Localize("word_items") + "</span><br /><b>" + data.preferredDeliveryDate + "</b>";


            var info = c.appendChild(document.createElement("span"));
            info.classList.add("orderinfo");

            console.log(data);

            if (data.productionItemInfo) {
                info.innerHTML = `<b>${data.productionItemInfo.sku}</b><br />${data.productionItemInfo.description}<br/>Qty: ${data.productionQuantity} - ${data.preferredDeliveryDate}`; 
                if (data.priority != 0) {
                    info.innerHTML += " - Priority: " + data.priority + "</b>";
                }

            }
            else {
                var name = data.recipient.name;
                if (data.recipient.attention) name += " (Att: " + data.recipient.attention + ")";
                var street = data.recipient.street1;
                if (data.recipient.street2) street += ", " + data.recipient.street2;
                info.innerHTML = "<b>" + name + "</b><br />" + street + "<br />" + data.recipient.country + "-" + data.recipient.zipcode + " " + data.recipient.city;
            }

      


            var cb = c.appendChild(document.createElement("input"));
            cb.type = "checkbox";

            var cbd = new SP.CheckboxDoodle(cb);
            this.items.push(new OrderData(c, cbd, data));

            cbd.onChange = () => {
                c.style.color = cbd.checked ? "" : "#9f9f9f";
            }


        }

    }


    export class App_Generate_Picklist extends AppBase {
        //gpl_prioritize_deadline = new SP.CheckboxDoodle(document.getElementById("gpl_prioritize_deadline") as HTMLInputElement);
        //gpl_prioritize_old = new SP.CheckboxDoodle(document.getElementById("gpl_prioritize_old") as HTMLInputElement);
        gpl_prime_picklist = new SP.CheckboxDoodle(document.getElementById("gpl_prime_picklist") as HTMLInputElement);
        gpl_allow_refill_picks = new SP.CheckboxDoodle(document.getElementById("gpl_allow_refill_picks") as HTMLInputElement);
        //gpl_size_preference = document.getElementById("gpl_size_preference") as HTMLSelectElement;
        gpl_max_orders = new SP.NumberDoodle(document.getElementById("gpl_max_orders") as HTMLInputElement);
        //gpl_max_locations = new SP.NumberDoodle(document.getElementById("gpl_max_locations") as HTMLInputElement);
        //gpl_max_items = new SP.NumberDoodle(document.getElementById("gpl_max_items") as HTMLInputElement);
        //gpl_max_weight_gram_list = new SP.NumberDoodle(document.getElementById("gpl_max_weight_gram_list") as HTMLInputElement);
        //gpl_max_weight_gram_item = new SP.NumberDoodle(document.getElementById("gpl_max_weight_gram_item") as HTMLInputElement);
        //gpl_min_weight_gram_item = new SP.NumberDoodle(document.getElementById("gpl_min_weight_gram_item") as HTMLInputElement);
        //gpl_item_priority = new SP.SortableList(document.getElementById("gpl_item_priority"));
        //settings_group = document.getElementById("generate_picklist_settings");
        //settings_button = document.getElementById("generate_picklist_settings_button");
        generate_button = document.getElementById("generate_picklist_generate_button");
        gpl_filter_button = document.getElementById("gpl_filter_button");
        profile_buttons = document.getElementById("generate_picklist_profile_buttons");
        focus_buttons = document.getElementById("gpl_focus_buttons");
        customer_buttons = document.getElementById("generate_customer_buttons");
        gpl_pick_count = document.querySelector("#gpl_pick_count");
        settings: { [customerId: string]: SP.PickSettingInfo } = {};
        currentSettings: SP.PickSettingInfo;
        currentplacementId: number;
        bound = false;
        generating = false;
        placementId: number = null;
        customerId: string = null;
        assistant = new PickAssistant();
        static instance: App_Generate_Picklist;

        constructor() {
            super("app_generate_picklist");

            App_Generate_Picklist.instance = this;

            this.assistant.onClose = () => {
                this.gpl_pick_count.innerHTML = this.assistant.picks.length == 0 ? "Auto" : this.assistant.picks.length + " " + SP.Localize("word_picked");
            }


            this.gpl_filter_button.addEventListener("click", () => {
                if (this.currentSettings != null)
                    this.assistant.open(this.currentSettings.id, this.currentSettings.name);
            });

            this.generate_button.addEventListener("click", async () => {
                //prevent double generation
                if (this.generating) return;
                this.generating = true;

                //start loading
                StartLoading();


                //Post config (generate list)
                console.log(this.currentSettings);
                var result: any = await SP.post("/API/V1/PickList/Create", {
                    startLocationId: this.placementId,
                    customerId: this.customerId,
                    pickSettings: this.currentSettings,
                    orderIds: this.assistant.picks
                });

                //stop loading
                StopLoading();

                //clear generating
                this.generating = false;

                if (result.status == 200) {
                    //open list
                    await SP.setAllHash({ "app": "app_picklist", "id": result.listId });
                }
                else {
                    await SP.alertX(result.status + ": " + result.msg);
                }
            });


            this.gpl_prime_picklist.onChange = () => {
                this.currentSettings.primePicklist = this.gpl_prime_picklist.checked;
            }


            this.gpl_allow_refill_picks.onChange = () => {
                this.currentSettings.allowRefillPicks = this.gpl_allow_refill_picks.checked;
            }

            this.gpl_max_orders.onChange = () => {
                this.currentSettings.maxOrders = this.gpl_max_orders.intValue;
            }

          

            container.appendChild(this.assistant.container);
        }

        async setStockSettings() {
            var settings = this.currentSettings;
            this.gpl_prime_picklist.checked = settings.primePicklist;
            this.gpl_max_orders.value = settings.maxOrders.toString();


        }
        initialized: boolean = false;

        customerCountLabels: { [id: string]: HTMLElement } = {};
        deadlineCountLabels: { [id: string]: HTMLElement } = {};

        async Init() {
            if (!this.initialized) {


                var customers = await SP.Data.Customer.getCustomerInfos(true);

                customers.sort((a, b) => a.customerName.localeCompare(b.customerName));

                var selectedCustomerId = localStorage.getItem("generate_selected_customer");
                if (!selectedCustomerId) {
                    selectedCustomerId = customers[0].customerId;
                }

                this.initialized = true;
                this.customer_buttons.innerHTML = "";
                for (let i = 0; i < customers.length; i++) {
                    let c = customers[i];
                    let btn = this.customer_buttons.appendChild(createListButton("stock_list_button", c.customerName, () => {
                        this.selectCustomer(c.customerId);
                        localStorage.setItem("generate_selected_customer", c.customerId);
                        var current = document.querySelector(".stock_list_button.selected");
                        if (current) current.classList.remove("selected");
                        btn.classList.add("selected");
                    }));

                    let label = this.customerCountLabels[c.customerId] = btn.appendChild(document.createElement("span"));
                    label.classList.add("label", "stock_count_" + c.customerId);
                    label.innerHTML = "0";
                    label.style.backgroundColor = "rgb(197, 197, 197)";
                    if (selectedCustomerId == c.customerId)
                        btn.click();


                }
            }


        }

        updateFocussedState() {
            var hasFocus = this.focus_buttons.querySelector(".selected") != null;
            this.focus_buttons.classList.toggle("has_focus", hasFocus);

        }

        async onOpen() {
            if (!this.initialized)
                await this.Init();

            else if (this.customerId) {
                //force reload counts on open
                var customer = this.customerId;
                this.customerId = null;
                this.selectCustomer(customer);
            }




            var deadlines = await SP.Data.Deadline.getDeadlineInfos();
            console.log("DEADLINSE", deadlines);
            this.focus_buttons.innerHTML = "";
            for (let i = 0; i < deadlines.length; i++) {
                let d = deadlines[i];
                let btn = this.focus_buttons.appendChild(createListButton("deadline_list_button", d.name, async () => {
                    var result = await SP.get<any>("/api/v1/sortingzone/toggleFocus/" + d.sortingZoneId);
                    btn.classList.toggle("selected", result.data);
                    this.updateFocussedState();
                }));


                let dl = this.deadlineCountLabels[d.sortingZoneId] = btn.appendChild(document.createElement("span"));
                dl.classList.add("deadline_label", "label");
                dl.innerHTML = d.deadline;



                let label = this.deadlineCountLabels[d.sortingZoneId] = btn.appendChild(document.createElement("span"));
                label.classList.add("label");
                label.innerHTML = "<span class='deadline_count_" + d.sortingZoneId + "'>" + d.orderCount +"</span>";
                label.style.backgroundColor = "rgb(197, 197, 197)";

                if (d.passed) {
                    btn.classList.add("passed_deadline");
                }

                if (d.prioritized) {
                    let il = label.appendChild(document.createElement("span"));
                    il.classList.add("inner-label", "prioritize-label");
                    il.innerHTML = SP.Localize("word_prioritized");
                }

                let il2 = label.appendChild(document.createElement("span"));
                il2.classList.add("inner-label", "focus-label");
                il2.style.display = "none";
                il2.innerHTML = SP.Localize("word_focussed");


                if (d.focussed) btn.classList.add("selected");

                this.updateFocussedState();

            }




            var readyCounts = await hub.connection.invoke<{ [id: string]: number }>("GetReadyCounts") as any;
            var stockCounts = readyCounts.stock;
            var deadlineCounts = readyCounts.deadline;
            this.updateStockCounts(stockCounts);
            this.updateDeadlineCounts(deadlineCounts);

            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("sp", this.scanPlacementId, this);
            }

        }

        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacementId);
            }
        }




 
        async selectCustomer(customerId: string) {
            if (customerId == null || !customerId.length || customerId == this.customerId) return;

            this.customerId = customerId;
            this.currentplacementId = null;
            var profiles = (await SP.Data.PickProfile.getPickProfileInfos(customerId));

            var selectedProfileId = localStorage.getItem("profile_" + customerId);
            if (!selectedProfileId) {
                selectedProfileId = profiles[0].id;
            }

            //Load profile buttons
            this.profile_buttons.innerHTML = "";

            var additionalCount = 0;
            var additionalRefilCount = 0;
            var additionalBtns = [] as HTMLElement[];

            for (let i = 0; i < profiles.length; i++) {
                let p = profiles[i];

                var name = p.name;

                if (p.orderFifoMode > 0 && p.oldestOrderDate) {
                    name += `<div class='date-label'>${p.oldestOrderDate}</div>`;
                }

                let btn = this.profile_buttons.appendChild(createListButton("profile_list_button", name, () => {
                    this.currentSettings = p;
                    this.setStockSettings();
                    localStorage.setItem("profile_" + customerId, p.id);
                    var current = document.querySelector(".profile_list_button.selected");
                    if (current) current.classList.remove("selected");
                    btn.classList.add("selected");
                    this.assistant.clear();
                    this.assistant.onClose(); //update text
                }));
                console.log("PROFILE:", p);
                var label = btn.appendChild(document.createElement("span"));
                label.classList.add("label");

                if (p.orderCountIfRefill) {
                    label.innerHTML = '<span class="inner-label">' + p.orderCountIfRefill + ' Refill</span> ' + p.orderCount.toString();
                }
                else label.innerHTML = p.orderCount.toString();


                //hide if other fulfillmentlocation
                if (App_Settings.wmsSettings.fulfillment_location != 'global' && p.fulfillmentLocation != App_Settings.wmsSettings.fulfillment_location) {
                    btn.style.display = "none";
                    additionalBtns.push(btn);
                    additionalRefilCount += p.orderCountIfRefill;
                    additionalCount += p.orderCount;
                }



                label.style.backgroundColor = p.orderCount == 0 ? "#c5c5c5" : "";

                if (selectedProfileId == p.id)
                    btn.click();

                if (App_Settings.userSettings.hide_empty_pick_profiles) btn.style.display = p.orderCount == 0 ? "none" : "flex";
            }


            if (additionalBtns.length > 0 && additionalCount + additionalRefilCount > 0) {
                var btn = this.profile_buttons.appendChild(createListButton("profile_list_button", SP.Localize("sentance_other_fulfillment_locations"), async () => {
                    if (await SP.confirmX(SP.Localize("word_show") + ' ' +SP.Localize("sentance_other_fulfillment_locations") + '?')) {
                        //show all hidden buttons and hide this
                        additionalBtns.forEach(b => b.style.display = "flex");
                        btn.style.display = "none";
                    }

                }));

                btn.style.backgroundColor = "#cfcfcf";

                var label = btn.appendChild(document.createElement("span"));
                label.classList.add("label");

                if (additionalRefilCount > 0) label.innerHTML = '<span class="inner-label">' + additionalRefilCount + ' Refill</span> ' + additionalCount;
                else label.innerHTML = additionalCount.toString();

                label.style.backgroundColor = additionalCount == 0 ? "#c5c5c5" : "";
            };
        }




        updateStockCounts(data: { [id: string]: number }) {
            //hide all 
            if (App_Settings.userSettings.hide_empty_pick_profiles) {
                this.customer_buttons.childNodes.forEach(c => { (c as HTMLElement).style.display = App_Settings.userSettings.hide_empty_pick_profiles ? "none" : "flex"; });
            }

            for (let id in data) {
                var v = data[id].toString()
                let label = this.customerCountLabels[id];
                if (label) {
                    label.innerHTML = v;
                    label.style.backgroundColor = data[id] == 0 ? "#c5c5c5" : "";
                    if (v != "0") label.parentElement.style.display = "flex";
                }
                else {
                    console.log("Error customer not found: " + id);
                }
            }
        }


        updateDeadlineCounts(data: { [id: string]: number }) {
            //hide all 
            if (App_Settings.userSettings.hide_empty_pick_profiles) {
                this.focus_buttons.childNodes.forEach(c => { (c as HTMLElement).style.display = App_Settings.userSettings.hide_empty_pick_profiles ? "none" : "flex"; });
            }

            for (let id in data) {
                console.log(data, "Value:" + v);
                var v = data[id].toString()
                let label = this.deadlineCountLabels[id];
                if (!label) continue;
                label.querySelector("span").innerHTML = data[id].toString();
                label.style.backgroundColor = data[id] == 0 ? "#c5c5c5" : "";
                if (v != "0") label.parentElement.style.display = "flex";
            }
        }

        async scanPlacementId(placementId: string) {

            this.placementId = parseInt(placementId);
            var data = await SP.Data.Stock.getPlacementInfo(this.placementId);
            var c = await SP.Data.Customer.getCustomerInfo(this.customerId, true);


            if (c.stockId != data.stock.stockId)
                return await SP.alertX("Wrong stock! scan customer stock!");


            this.currentplacementId = this.placementId;
            this.generate_button.click();
        }


    }



    RegisterApp("app_generate_picklist", App_Generate_Picklist);
}